const onlyNumbers = text => (text ? String(text).replace(/\D/g, '') : '');

export default onlyNumbers;
